import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { externalApiPermissions } from './permissions';

const ExternalApiPage = React.lazy(
  () => import('./components/ExternalApiPage')
);

export const externalApiRoutes: RouteObject = {
  path: externalApiPermissions.path,
  element: (
    <PermissionsProtectedRoute
      pageId={externalApiPermissions.pageId}
      currentPath={externalApiPermissions.path}
    />
  ),
  children: [
    {
      path: externalApiPermissions.path,
      element: (
        <React.Suspense fallback={null}>
          <ExternalApiPage />
        </React.Suspense>
      ),
    },
  ],
};
